import ProfilePage from '@pages/ProfilePage.vue';
import AccountContainer from '@modules/userProfile/account/AccountContainer.vue';
import HistoryContainer from '@modules/userProfile/history/HistoryContainer.vue';
import DepositContainer from '@modules/userProfile/deposit/DepositContainer.vue';
import WithdrawalContainer from '@modules/userProfile/withdrawal/WithdrawalContainer.vue';
import SettingsContainer from '@modules/userProfile/settings/SettingsContainer.vue';
import DocumentUploadContainer from '@modules/userProfile/documentUpload/DocumentUploadContainer.vue';
import TicketsContainer from '@modules/tickets/TicketsContainer.vue';
import PasswordUpdateContainer from '@modules/userProfile/settings/PasswordUpdateContainer.vue';
import {
    links,
    routeNames,
    titles
} from '@app/router/constants';
import {
    addLoginRequirements,
    getDefaultLayout,
} from '@app/router/utils';
import { AccountSubNav } from '@app/mobile/subnavs';

const children = [
    {
        path: '',
        name: routeNames.profile,
        component: AccountContainer,
    },
    {
        path: links.history,
        name: routeNames.history,
        component: HistoryContainer,
        meta: {
            title: titles.history
        },
    },
    {
        path: links.deposit,
        name: routeNames.deposit,
        component: DepositContainer,
        meta: {
            title: titles.deposit
        },
    },
    {
        path: links.withdrawal,
        name: routeNames.withdrawal,
        component: WithdrawalContainer,
        meta: {
            title: titles.withdrawal
        },
    },
    {
        path: links.settings,
        name: routeNames.settings,
        component: SettingsContainer,
        meta: {
            title: titles.settings
        },
    },
    {
        path: links.tickets,
        name: routeNames.tickets,
        component: TicketsContainer,
        meta: {
            title: titles.tickets,
        },
    },
    {
        path: links.passwordUpdate,
        name: routeNames.passwordUpdate,
        component: PasswordUpdateContainer,
        meta: {
            title: titles.passwordUpdate,
        },
    },
    {
        path: links.documentUpload,
        name: routeNames.documentUpload,
        component: DocumentUploadContainer,
        meta: {
            title: titles.documentUpload
        },
    }
];

export default [
    addLoginRequirements({
        path: links.profile,
        name: routeNames.profile,
        components: {
            ...getDefaultLayout(ProfilePage),
            mobileSubnav: AccountSubNav,
        },
        children: children.map(addLoginRequirements),
        meta: {
            title: titles.profile
        },
    }),
];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/router/routes/account.ts